import { Component, Input } from '@angular/core';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { FiniteStateMachineModel } from 'src/app/core/models/finiteStateMachines/finite-state-machine.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { Roles } from 'src/app/core/security/roles';
import { IntervalEnum } from 'src/app/core/enums/intervals-enum';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { FsmApiService } from 'src/app/core/services/fsmApi.service';

@Component({
  selector: 'app-finite-state-machine-modal',
  templateUrl: './finite-state-machine-modal.component.html',
  styleUrls: ['./finite-state-machine-modal.component.scss']
})

export class FiniteStateMachineModalComponent extends BaseModalComponent {

  fsmIntervalAvailableOptions = [
    { value: IntervalEnum.OneMinute, text: $localize`:@@FSM_Status_Text_One_Minute:One Minute` },
    { value: IntervalEnum.TwoMinutes, text: $localize`:@@FSM_Status_Text_Two_Minutes:Two Minutes` },
    { value: IntervalEnum.FiveMinutes, text: $localize`:@@FSM_Status_Text_Five_Minutes:Five Minutes` },
    { value: IntervalEnum.ThirtyMinutes, text: $localize`:@@FSM_Status_Text_Thirty_Minutes:Thirty Minutes` },
    { value: IntervalEnum.OneHour, text: $localize`:@@FSM_Status_Text_One_Hour:One Hour` },
    { value: IntervalEnum.FourHours, text: $localize`:@@FSM_Status_Text_Four_Hours:Four Hours` },
    { value: IntervalEnum.SixHours, text: $localize`:@@FSM_Status_Text_Six_Hours:Six Hours` },
    { value: IntervalEnum.TwelveHours, text: $localize`:@@FSM_Status_Text_Twelve_Hours:Twelve Hours` },
    { value: IntervalEnum.OneDay, text: $localize`:@@FSM_Status_Text_One_Day:One Day` },
    { value: IntervalEnum.OneWeek, text: $localize`:@@FSM_Status_Text_One_Week:One Week` },
    { value: IntervalEnum.OneMonth, text: $localize`:@@FSM_Status_Text_One_Month:One Month` },
    { value: IntervalEnum.EndOfDay, text: $localize`:@@FSM_Status_Text_End_Of_Day:End Of Day` },
    { value: IntervalEnum.EndOfMonth, text: $localize`:@@FSM_Status_Text_End_Of_Month:End Of Month` },
    { value: IntervalEnum.EndOfYear, text: $localize`:@@FSM_Status_Text_End_Of_Year:End Of Year` }
  ];

  securityPermissionFSMCreate: boolean = this.authMyFileService.isInRole(Roles.admin);
  securityPermissionFSMDelete: boolean = this.authMyFileService.isInRole(Roles.admin);
  securityPermissionFSMUpdate: boolean = this.authMyFileService.isInRole(Roles.admin);

  @Input() public override model: FiniteStateMachineModel = new FiniteStateMachineModel;

  constructor(
    protected fsmApiService: FsmApiService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  ngOnInit(): void {
    if (this.model.id === undefined) {
      this.newModel = true;
    }
  }

  ngOnDestroy(): void {
    this.model = new FiniteStateMachineModel;
  }

  validate(): boolean {
    if (this.model) {
      if (
        this.model.name != undefined && this.model.name.length > 0
        && this.model.interval != undefined
      ) {
        if (this.model.isEnabled === undefined) {
          this.model.isEnabled = false;
        }
        this.model.interval = Number(this.model.interval); //need this to be a number else the enum is interpreted as a string when JSONing the object
        return true;
      }
    }
    return false;
  }

  onUpdate(): void {
    this.disableEditing = true;
    this.fsmApiService.updateFiniteStateMachines(this.model).subscribe(
      (result: boolean | undefined) => {
        if (result) {
          this.toasterNotificationService.showSuccess($localize`:@@:Machine Updated`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        this.submitted = false;
        this.disableEditing = false;
        this.close();
      }
    )
  }

  onCreate(): void {
    this.disableEditing = true;
    this.fsmApiService.newFiniteStateMachines(this.model).subscribe(
      (result: boolean | undefined) => {
        if (result) {
          this.toasterNotificationService.showSuccess($localize`:@@:Machine Created`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        this.submitted = false;
        this.disableEditing = false;
        this.close();
      }
    )
  }
}
